import { render, staticRenderFns } from "./OrganizerNoEmailError.vue?vue&type=template&id=35c8a486&"
import script from "./OrganizerNoEmailError.vue?vue&type=script&lang=js&"
export * from "./OrganizerNoEmailError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c8a486')) {
      api.createRecord('35c8a486', component.options)
    } else {
      api.reload('35c8a486', component.options)
    }
    module.hot.accept("./OrganizerNoEmailError.vue?vue&type=template&id=35c8a486&", function () {
      api.rerender('35c8a486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Invitees/OrganizerNoEmailError.vue"
export default component.exports